"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPinoAdapter = void 0;
var createPinoAdapter = function (pino) {
    var instance = pino;
    instance.level = "debug";
    return {
        format: function (_level, _context) {
            var args = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args[_i - 2] = arguments[_i];
            }
            return args;
        },
        output: function (level, _context, msg) { return instance[level](msg); },
    };
};
exports.createPinoAdapter = createPinoAdapter;
//# sourceMappingURL=pinoAdapter.js.map